import Platform from "react-native-web/dist/exports/Platform";
import PropTypes from 'prop-types';
import rectProp from './rectProp';
import getPropSelector from './getPropSelector';
const pressHandlerPropTypes = {
  onPress: PropTypes.func,
  onPressIn: PropTypes.func,
  onPressOut: PropTypes.func,
  ...Platform.select({
    web: {
      onMouseEnter: PropTypes.func,
      onMouseLeave: PropTypes.func,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func
    },
    default: {
      onLongPress: PropTypes.func
    }
  })
};
export const pressPropTypes = {
  ...pressHandlerPropTypes,
  disabled: PropTypes.bool,
  ...Platform.select({
    web: {},
    default: {
      hitSlop: PropTypes.number,
      pressRetentionOffset: PropTypes.oneOfType([PropTypes.number, rectProp.propType])
    }
  })
};
export default {
  /**
   * Proptypes for clickable or pressable components, including web-only props
   */
  types: pressPropTypes,
  /**
   * Filters a props object, returning only the platform-relevant press props defined above
   */
  select: getPropSelector(pressPropTypes),
  selectHandlers: getPropSelector(pressHandlerPropTypes)
};